const convertToHex = (num: number): string => {
  return num.toString(16).padStart(2, "0");
};

export const getChecksum = async (
  algorithm: string,
  content: string | Blob
): Promise<string> => {
  let buffer;
  if (typeof content === "string") {
    buffer = new TextEncoder().encode(content);
  } else if (content instanceof Blob) {
    buffer = await content.arrayBuffer();
  } else {
    buffer = content;
  }

  const hash = await crypto.subtle.digest(algorithm, buffer);
  const hex = Array.from(new Uint8Array(hash), convertToHex).join("");
  return hex;
};
